<!-- HEADER -->
<app-header color="transparent"></app-header>

<!-- CONTENT -->
<ion-content class="padded">
  <section *ngIf="data" class="page-content">
    <!-- BREADCRUMBS -->
    <ul class="breadcrumb">
      <li>
        <a [routerLink]="'/'">Home</a
        ><ion-icon name="chevron-forward-outline"></ion-icon>
      </li>
      <li>
        <span>What's On</span
        ><ion-icon name="chevron-forward-outline"></ion-icon>
      </li>
      <li>
        <a [routerLink]="'/competitions'">Competitions</a
        ><ion-icon name="chevron-forward-outline"></ion-icon>
      </li>
      <li class="active">{{data.title}}</li>
    </ul>

    <!-- HEADING, SOCIAL SHARING & FAVORITE -->
    <ion-grid class="page-header ion-no-padding">
      <ion-row>
        <ion-col>
          <ion-text color="dark">
            <h1 class="h2 page-title">{{data.title}}</h1>
          </ion-text>
          <ion-text color="tertiary">
            <p class="meta">
              <ng-container *ngIf="startDate && !futureDated; else futureComp">
                ENDS {{ endDate | date: "d MMM y" | uppercase }}
              </ng-container>
              <ng-template #futureComp>
                {{ startDate | date: "d MMMM y" | uppercase }} - {{ endDate |
                date: "d MMMM y" | uppercase }}
              </ng-template>
            </p>
          </ion-text>
        </ion-col>
        <ion-col size="auto" class="page-header-actions">
          <ion-row class="ion-align-items-center ion-justify-content-end">
            <!-- SOCIAL SHARING -->
            <ion-col size="auto" class="social-share">
              <a (click)="presentPopover($event)">
                <ion-icon
                  color="dark"
                  name="share-outline"
                  slot="icon-only"
                ></ion-icon>
              </a>
            </ion-col>
            <!-- FAVORTIE -->
            <ion-col size="auto" class="favorite">
              <app-favorite-item
                [title]="data.title"
                [slug]="data.slug"
              ></app-favorite-item>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
    </ion-grid>

    <!-- FEATURED IMAGE -->
    <app-image
      [node]="featuredImage"
      [disableLazyLoad]="true"
      class="competition-featured-image"
      [sponsor]="data?.advertise"
    ></app-image>

    <!-- BODY -->
    <app-dynamic-html
      [data]="data?.body"
      [formTitle]="data.title"
    ></app-dynamic-html>

    <!-- SPONSOR STRIP -->
    <app-sponsor-strip
      *ngIf="data?.advertise"
      [sponsorStrip]="data?.advertise"
    ></app-sponsor-strip>
  </section>

  <!-- RELATED CONTENT -->
  <section *ngIf="relatedContent && relatedContent.length > 0">
    <app-related-content
      [data]="{title: 'More Competitions', items: relatedContent }"
    ></app-related-content>
  </section>

  <!-- CONTACT / CTA STRIP -->
  <app-contact-strip></app-contact-strip>

  <!-- FOOTER -->
  <app-footer></app-footer>
</ion-content>
